module.exports = `${require.publicPath}download-img.5f95aa1e.png`;